<template>
  <section
    :class="classes"
  >
    <div class="course-block__wrapper">
      <h2
        :class="`course-block__title--margin-${titleMargin}`"
        class="course-block__title h h--3"
      >
        <slot name="title" />
      </h2>

      <slot name="content" />
    </div>
  </section>
</template>

<script setup lang="ts">
  const props = withDefaults(defineProps<{
    theme?: 'white' | 'grey';
    titleMargin?: 'small' | 'big';
  }>(), {
    theme: 'white',
    titleMargin: 'big'
  })

  const classes = computed(() => {
    return [
      'course-block',
      `course-block--${props.theme}`,
    ]
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;

  .course-block {
    &--grey {
      margin-right: 6px;
      margin-left: 6px;
      padding-top: 32px;
      padding-bottom: 32px;
      border-radius: 16px;
      background-color: var(--bg-secondary-color);

      @include media(lg) {
        padding: 56px 32px;
      }

      @include media(xl, xl-max) {
        padding-right: 96px;
        padding-left: 96px;
      }

      @include media(1600) {
        padding-right: 80px;
        padding-left: 80px;
      }

      .course-block__wrapper {
        padding-right: 14px;
        padding-left: 14px;

        @include media(md) {
          padding-right: 30px;
          padding-left: 30px;
        }

        @include media(lg) {
          padding: 0;
        }
      }
    }
  }

  /* stylelint-disable no-descending-specificity */
  .course-block__wrapper {
    padding-right: 20px;
    padding-left: 20px;

    @include media(md) {
      padding-right: 36px;
      padding-left: 36px;
    }

    @include media(lg) {
      width: 608px;
      padding: 0;
    }

    @include media(xl, xl-max) {
      width: 672px;
      padding-left: 20px;
    }

    @include media(xxl) {
      width: 848px;
    }
  }
  /* stylelint-enable no-descending-specificity */

  .course-block__title {
    margin-bottom: 16px;

    &--margin-big {
      margin-bottom: 24px;

      @include media(lg) {
        margin-bottom: 40px;
      }
    }
  }
</style>
